import React from 'react';
import { HighlightMetricsContentfulModel } from 'src/api/models/HighlightMetrics';
import HighlightMetrics from 'src/organisms/articles/caseStudies/caseStudies.highlightMetrics';
import styled, { css } from 'styled-components';

const HighlightMetricsContainer = styled.div<{ fontSize?: number }>`
  width: 100%;

  ${({ fontSize }) => !fontSize ? '' : css`
    p {
      font-size: ${fontSize}px;
    }
  `}
`

export default function getDynamicHighlightMetrics(highlightMetricsProps: HighlightMetricsContentfulModel): React.ReactNode {
  return (
    <HighlightMetricsContainer fontSize={highlightMetricsProps.fontSize}>
      <HighlightMetrics
        launchDate={highlightMetricsProps.launchDate}
        members={highlightMetricsProps.members}
        pricing={highlightMetricsProps.pricing}
      />
    </HighlightMetricsContainer>
  );
}
